module.exports = __webpack_public_path__ + "static/media/mm.551710c5.svg";